// Majesty (Jupiter): every star of the constellation surrounding Jupiter
// takes the base value of the word's highest letter (the letters' own
// values, before any addition).
import { letterValue } from '../../scoring/letterValues';
import { ownIndex } from '../shared/own';
import type { AlignmentDef } from '../types';

export const majesty: AlignmentDef = {
  id: 'majesty',
  planet: 'jupiter',
  name: 'Majesty',
  text: () => 'Every star of the constellation that surrounds Jupiter takes the base value of its highest letter.',
  baseSet: (star, c, ctx) => {
    if (c.index !== ownIndex(ctx, 'majesty')) return undefined;
    let highest = star.base;
    for (const node of c.nodes) highest = Math.max(highest, letterValue(ctx.level.lang, node.letter));
    return highest;
  },
};
